function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var H = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty,
    d = Object.prototype.propertyIsEnumerable;

var t = function t(l, e, C) {
  return e in l ? H(l, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: C
  }) : l[e] = C;
},
    n = function n(l, e) {
  for (var C in e || (e = {})) {
    r.call(e, C) && t(l, C, e[C]);
  }

  if (o) {
    var _iterator = _createForOfIteratorHelper(o(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var C = _step.value;
        d.call(e, C) && t(l, C, e[C]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return l;
};

import * as i from "react";

function v(l) {
  return i.createElement("svg", n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, l), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0833 17.2353H21.1667V5.76471C21.1667 4.79412 20.3417 4 19.3333 4H4.66667C3.65833 4 2.83333 4.79412 2.83333 5.76471V17.2353H1.91667C1.4125 17.2353 1 17.6324 1 18.1176C1 18.6029 1.4125 19 1.91667 19H22.0833C22.5875 19 23 18.6029 23 18.1176C23 17.6324 22.5875 17.2353 22.0833 17.2353ZM13.375 17.2353H10.625C10.3683 17.2353 10.1667 17.0412 10.1667 16.7941C10.1667 16.5471 10.3683 16.3529 10.625 16.3529H13.375C13.6317 16.3529 13.8333 16.5471 13.8333 16.7941C13.8333 17.0412 13.6317 17.2353 13.375 17.2353ZM4.66667 14.5882H19.3333V6.64706C19.3333 6.16176 18.9208 5.76471 18.4167 5.76471H5.58333C5.07917 5.76471 4.66667 6.16176 4.66667 6.64706V14.5882Z",
    fill: "black"
  }));
}

export { v as ReactComponent };